import requests from "utils/httpService";

const putRequests = {
  forgotPassword: (values) =>
    requests.manageServiceRequests.put(
      "/customers/customer/password/change/request",
      values
    ),
  resetPassword: (values) =>
    requests.manageServiceRequests.put(
      "/customers/customer/password/reset",
      values
    ),
  updateCustomerDetails: (values) =>
    requests.manageServiceRequests.put("/customers/customer", values),
  activeLoyaltyUserAccount: (values) =>
    requests.manageServiceRequests.put("/customers/activate", values),
  resendOTPtoActivateLoyaltyAccount: (values) =>
    requests.manageServiceRequests.put(
      "/customers/customer/activate/request",
      values
    ),
  verifyWalletNumber: (values) =>
    requests.manageServiceRequests.put(
      `/customers/customer/property/wallets/validate`,
      values
    ),
  resendWalletOTP: (values) =>
    requests.manageServiceRequests.put(
      `/customers/customer/property/wallets/resend`,
      values
    ),
};

export default putRequests;
